import calendarEventRepository from '@/repositories/calendar-event.repository';
import { ICalendarEvent } from '@/types/calendar-event/ICalendarEvent';
import { UseQueryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryClient } from './query-client';

type IUseListCalendarEventsArgs = Parameters<typeof calendarEventRepository.list>[0];

export function useListCalendarEvents(
	args: IUseListCalendarEventsArgs,
	options?: Partial<UseQueryOptions<unknown, unknown, Awaited<ReturnType<typeof calendarEventRepository.list>>>>
) {
	return useQuery({
		queryKey: ['calendar-event', 'list', args],
		queryFn: () => calendarEventRepository.list(args),
		...options,
	});
}

type IUseGetCalendarEventsArgs = Parameters<typeof calendarEventRepository.get>[0] & {
	enabled?: boolean;
};

export function useGetCalendarEvent(args: IUseGetCalendarEventsArgs) {
	return useQuery({
		enabled: args.enabled,
		queryKey: ['calendar-event', 'get', args.id],
		queryFn: () => calendarEventRepository.get(args),
	});
}

export function setCalendarEventData(data: ICalendarEvent) {
	return queryClient.setQueryData(['calendar-event', 'get', data.id], data);
}

export function useCreateCalendarEventMutation() {
	const client = useQueryClient();

	return useMutation({
		mutationFn: calendarEventRepository.create,
		onSuccess() {
			client.invalidateQueries({ queryKey: ['calendar-event'] });
		},
	});
}

export function useRemoveCalendarEventMutation() {
	const client = useQueryClient();

	return useMutation({
		mutationFn: calendarEventRepository.remove,
		onSuccess() {
			client.invalidateQueries({ queryKey: ['calendar-event'] });
		},
	});
}
